/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { WorkDTO } from './WorkDTO';
import {
    WorkDTOFromJSON,
    WorkDTOFromJSONTyped,
    WorkDTOToJSON,
    WorkDTOToJSONTyped,
} from './WorkDTO';

/**
 * 
 * @export
 * @interface SearchResultDTO
 */
export interface SearchResultDTO  {
    /**
     * 
     * @type {WorkDTO}
     * @memberof SearchResultDTO
     */
    workDTO?: WorkDTO;
    /**
     * 
     * @type {number}
     * @memberof SearchResultDTO
     */
    mmsId?: number;
}

/**
 * Check if a given object implements the SearchResultDTO interface.
 */
export function instanceOfSearchResultDTO(value: object): value is SearchResultDTO {
    return true;
}

export function SearchResultDTOFromJSON(json: any): SearchResultDTO {
    return SearchResultDTOFromJSONTyped(json, false);
}

export function SearchResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'workDTO': json['workDTO'] == null ? undefined : WorkDTOFromJSON(json['workDTO']),
                  'mmsId': json['mmsId'] == null ? undefined : json['mmsId'],
    };
}

export function SearchResultDTOToJSON(json: any): SearchResultDTO {
    return SearchResultDTOToJSONTyped(json, false);
}

export function SearchResultDTOToJSONTyped(value?: SearchResultDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workDTO': WorkDTOToJSON(value['workDTO']),
        'mmsId': value['mmsId'],
    };
}


